/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ActionType } from "~/generated/graphql";

export const ACTION_TYPE_LABEL_MAP: Record<ActionType, string> = {
  [ActionType.AwsLambda]: "AWS Lambda",
  [ActionType.AzureFunction]: "AZURE Function",
  [ActionType.Webhook]: "Webhook",
  [ActionType.SsmDocument]: "SSM Document",
  [ActionType.Script]: "Script",
};
